module.exports = __webpack_public_path__ + "img/objectinasentence.137074f1.png";